export default __webpack_public_path__ + "static/media/folder-open-solid.4e56e750.svg";